<template>
  <div class="row">
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />
    <div v-if="!this.$store.getters.isLoading" class="flex xs12">
      <div class="va-card">
        <div class="va-card__header-inner">
          <div class="va-card__header-title" style="color: rgb(44, 130, 224);"> {{ $t('payment.subscribeCompleted') }}</div>
        </div>
        <div class="va-card__body">
          <div v-if="need">
            <h4>{{ $t('payment.thankYouForCreating') }} {{subscriptionOverall.subscription.name}} {{ $t('payment.subscription') }} </h4>
            <p>
              {{ $t('payment.yourSubscription') }} {{subscriptionOverall.companySubscription.activeTo | moment("MMMM Do YYYY")}}, {{ $t('payment.toGetYourInvoice') }} <a href="#" @click="toInvoices">{{ $t('payment.clickHere') }}</a>.
            </p>
            <div class="row">
              <div class="flex xs12">
                <p style="padding: 10px;">{{ $t('payment.inOrder') }}</p>
                <ol style="padding: 10px;">
                  <li v-html="$t('payment.visitLocation')"></li>
                  <li v-html="$t('payment.visitSpot')"></li>
                  <li v-html="$t('payment.visitSubscriptions')"></li>
                  <li v-html="$t('payment.visitTriggers')"></li>
                  <li v-html="$t('payment.visitEmployees')"></li>
                  <li v-html="$t('payment.learnMore')"></li>
                </ol>
              </div>
            </div>
            <p>
              {{ $t('payment.dontHesitate') }}
            </p>
            <p style="padding-top: 10px; font-weight: bold;">
              {{ $t('payment.ourMission') }}
            </p>
          </div>
          <div v-if="!need">
            {{ $t('payment.notAnyPayment') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'

export default {
  components: { SwappingSquaresSpinner },
  mixins: [errorHandlerMixin],
  name: 'PaymentCompleted',
  data () {
    return {
      paymentInfo: {},
      invoice: {},
      payment: {},
      need: false,
      subscriptionOverall: {},
      companySubscription: {},
    }
  },
  methods: {
    async toInvoices (invoiceId) {
      await this.$router.push({
        name: 'invoices',
      })
    },
    async initPaymentCompleted (subscription) {
      this.invoice = this.$store.getters.paymentSuccess.invoice
      this.payment = this.$store.getters.paymentSuccess.payment
      this.companySubscription = this.$store.getters.paymentSuccess.subscription
      if (this.invoice && this.payment && this.companySubscription) {
        this.need = true
      }
      this.subscriptionOverall = subscription
      this.$store.commit('setLoading', false)
    },
  },
  computed: {
    theLocalStorageData () {
      return this.$store.getters.authenticationData
    },
  },
  watch: {
    theLocalStorageData (storage) {
      this.theLocalStorageData = storage
    },
  },
  mounted () {
    this.$store.commit('setLoading', true)
    this.$store.dispatch('getPaymentSuccess', this.$route.params.paymentId).then((resp) => this.initPaymentCompleted(resp.data.message))
      .catch((err) => this.errorHandler(err.response))
  },
}
</script>

<style scoped type="scss">
</style>
